import { render, staticRenderFns } from "./BulkActionsSelect.vue?vue&type=template&id=1d6aceb7&"
import script from "./BulkActionsSelect.vue?vue&type=script&lang=js&"
export * from "./BulkActionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports